// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__39Tgr","header":"ClearentDisclaimer_header__2FNGI","inner":"ClearentDisclaimer_inner__2T65J"};